// ─────────────────────────────────────────────────────────────────────────────
// eoh-2fa.js — Two-Factor Authentication (TOTP) UI
// Depends on: eoh-chat.js (API, S, updateUserUI, closeModal)
// Two flows:
//   1. Profile → Security → Enable/Disable 2FA
//   2. Login flow → TOTP step when totp_enabled = true
// ─────────────────────────────────────────────────────────────────────────────
'use strict';

(function() {

// ── Inject styles ─────────────────────────────────────────────────────────────
var _2faStyle = document.getElementById('eoh-2fa-style');
if (!_2faStyle) {
  var s = document.createElement('style');
  s.id = 'eoh-2fa-style';
  s.textContent = [
    '.tfa-overlay{position:fixed;inset:0;z-index:99999;background:rgba(0,0,0,.75);display:flex;align-items:center;justify-content:center;padding:20px;animation:eohFadeIn .2s ease}',
    '.tfa-box{background:#131722;border:1px solid rgba(255,255,255,.08);border-radius:16px;width:100%;max-width:420px;padding:28px;box-shadow:0 24px 64px rgba(0,0,0,.6)}',
    '.tfa-title{font-size:17px;font-weight:700;color:#e8edf5;margin-bottom:6px}',
    '.tfa-sub{font-size:12px;color:#7d8ba3;margin-bottom:20px;line-height:1.5}',
    '.tfa-qr{width:180px;height:180px;display:block;margin:0 auto 16px;border-radius:8px;border:3px solid #0fb574;background:#fff}',
    '.tfa-secret{background:#0a1520;border:1px solid #2d3f55;border-radius:8px;padding:10px 14px;font-family:monospace;font-size:13px;color:#0fb574;text-align:center;letter-spacing:2px;margin-bottom:16px;word-break:break-all;cursor:pointer}',
    '.tfa-secret:hover{border-color:#0fb574}',
    '.tfa-digits{display:flex;gap:8px;justify-content:center;margin-bottom:16px}',
    '.tfa-digit{width:42px;height:52px;text-align:center;font-size:22px;font-weight:700;background:#0f1923;border:2px solid #2d3f55;border-radius:8px;color:#e8edf5;outline:none;transition:border-color .15s}',
    '.tfa-digit:focus{border-color:#0fb574}',
    '.tfa-digit.tfa-filled{border-color:#0fb574}',
    '.tfa-err{font-size:12px;color:#f87171;text-align:center;min-height:18px;margin-bottom:10px}',
    '.tfa-ok{font-size:12px;color:#0fb574;text-align:center;min-height:18px;margin-bottom:10px}',
    '.tfa-btn{width:100%;padding:11px;background:linear-gradient(135deg,#0A8A5F,#0A4FCC);border:none;border-radius:8px;color:#fff;font-size:14px;font-weight:700;cursor:pointer;margin-bottom:10px;font-family:inherit}',
    '.tfa-btn:disabled{opacity:.5;cursor:default}',
    '.tfa-btn-sec{width:100%;padding:10px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.08);border-radius:8px;color:#7d8ba3;font-size:13px;cursor:pointer;font-family:inherit}',
    '.tfa-btn-sec:hover{background:rgba(255,255,255,.08);color:#e8edf5}',
    '.tfa-steps{counter-reset:step;margin-bottom:20px}',
    '.tfa-step{display:flex;gap:12px;margin-bottom:12px;align-items:flex-start}',
    '.tfa-step-n{flex-shrink:0;width:22px;height:22px;background:rgba(15,181,116,.15);border:1px solid rgba(15,181,116,.3);border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:11px;font-weight:700;color:#0fb574}',
    '.tfa-step-t{font-size:12px;color:#9ca3af;line-height:1.5;padding-top:2px}',
    '.tfa-step-t strong{color:#e8edf5}',
    '.tfa-divider{border:none;border-top:1px solid #2d3f55;margin:16px 0}',
    '@keyframes eohFadeIn{from{opacity:0;transform:scale(.96)}to{opacity:1;transform:scale(1)}}',
    '.tfa-card{background:#0f1923;border:1px solid #2d3f55;border-radius:12px;padding:16px;margin-bottom:16px}',
    '.tfa-card-row{display:flex;align-items:center;justify-content:space-between;gap:12px}',
    '.tfa-badge-on{display:inline-flex;align-items:center;gap:5px;padding:3px 10px;background:rgba(15,181,116,.12);color:#0fb574;border:1px solid rgba(15,181,116,.25);border-radius:20px;font-size:11px;font-weight:600}',
    '.tfa-badge-off{display:inline-flex;align-items:center;gap:5px;padding:3px 10px;background:rgba(100,116,139,.12);color:#7d8ba3;border:1px solid #2d3f55;border-radius:20px;font-size:11px;font-weight:600}',
  ].join('\n');
  document.head.appendChild(s);
}

// ── Helpers ───────────────────────────────────────────────────────────────────
function _2faApi(method, path, body, token) {
  var t = token || (window.S && window.S.token) || '';
  var opts = {
    method: method,
    headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + t }
  };
  if (body) opts.body = JSON.stringify(body);
  return fetch((window.API || 'https://erp-ai-backend.vercel.app') + path, opts)
    .then(function(r) { return r.json().then(function(d) { d._status = r.status; return d; }); });
}

function _2faGetDigits(prefix) {
  return [0,1,2,3,4,5].map(function(i) {
    var el = document.getElementById(prefix + i);
    return el ? el.value.trim() : '';
  }).join('');
}

function _2faSetupDigits(prefix, onComplete) {
  [0,1,2,3,4,5].forEach(function(i) {
    var el = document.getElementById(prefix + i);
    if (!el) return;
    el.addEventListener('input', function() {
      el.classList.toggle('tfa-filled', !!el.value);
      if (el.value && i < 5) {
        var next = document.getElementById(prefix + (i + 1));
        if (next) next.focus();
      }
      if (el.value && i === 5 && onComplete) onComplete();
    });
    el.addEventListener('keydown', function(e) {
      if (e.key === 'Backspace' && !el.value && i > 0) {
        var prev = document.getElementById(prefix + (i - 1));
        if (prev) { prev.value = ''; prev.classList.remove('tfa-filled'); prev.focus(); }
      }
      // Allow paste
      if (e.key === 'v' && (e.ctrlKey || e.metaKey)) {
        setTimeout(function() {
          var joined = [0,1,2,3,4,5].map(function(j){
            var x=document.getElementById(prefix+j); return x?x.value:'';
          }).join('');
          if (joined.length > 1) {
            // Redistribute pasted value
            var pasted = joined.replace(/\D/g,'').slice(0,6);
            for (var j = 0; j < 6; j++) {
              var xel = document.getElementById(prefix+j);
              if (xel) { xel.value = pasted[j]||''; xel.classList.toggle('tfa-filled', !!pasted[j]); }
            }
            var last = document.getElementById(prefix+Math.min(pasted.length,5));
            if (last) last.focus();
            if (pasted.length === 6 && onComplete) onComplete();
          }
        }, 10);
      }
    });
    // Handle paste on container
    el.addEventListener('paste', function(e) {
      e.preventDefault();
      var pasted = (e.clipboardData || window.clipboardData).getData('text').replace(/\D/g,'').slice(0,6);
      for (var j = 0; j < 6; j++) {
        var xel = document.getElementById(prefix+j);
        if (xel) { xel.value = pasted[j]||''; xel.classList.toggle('tfa-filled', !!pasted[j]); }
      }
      var last = document.getElementById(prefix+Math.min(pasted.length,5));
      if (last) last.focus();
      if (pasted.length === 6 && onComplete) onComplete();
    });
  });
}

function _digitInputsHtml(prefix) {
  return '<div class="tfa-digits">'
    + [0,1,2,3,4,5].map(function(i) {
        return '<input id="' + prefix + i + '" class="tfa-digit" type="tel" maxlength="1" inputmode="numeric" pattern="[0-9]*" autocomplete="one-time-code">';
      }).join('')
    + '</div>';
}

// ══════════════════════════════════════════════════════════════════════════════
// FLOW 1 — Profile Security Section
// ══════════════════════════════════════════════════════════════════════════════

// ── Render 2FA card in profile modal ─────────────────────────────────────────
window.render2FACard = function(container, totpEnabled) {
  if (!container) return;
  var enabled = !!totpEnabled;
  container.innerHTML = '<div class="tfa-card">'
    + '<div class="tfa-card-row">'
    + '<div>'
    + '<div style="font-size:13px;font-weight:700;color:#e8edf5;margin-bottom:3px">🔐 Two-Factor Authentication</div>'
    + '<div style="font-size:11px;color:#7d8ba3">Protect your account with an authenticator app</div>'
    + '</div>'
    + (enabled
        ? '<span class="tfa-badge-on">● Enabled</span>'
        : '<span class="tfa-badge-off">○ Off</span>')
    + '</div>'
    + '<hr class="tfa-divider">'
    + (enabled
        ? '<button class="tfa-btn-sec" onclick="show2FADisable()" style="max-width:200px">Disable 2FA</button>'
        : '<button class="tfa-btn" onclick="show2FASetup()" style="max-width:200px">Enable 2FA</button>')
    + '</div>';
};

// ── Show 2FA Setup Modal (QR code flow) ──────────────────────────────────────
var _2faEnrolling = false;
window.show2FASetup = async function() {
  if (_2faEnrolling) return; // prevent double-call
  _2faEnrolling = true;
  // Remove any existing overlay
  var ex = document.getElementById('tfa-overlay');
  if (ex) ex.remove();

  // Show loading overlay
  var overlay = document.createElement('div');
  overlay.id = 'tfa-overlay';
  overlay.className = 'tfa-overlay';
  overlay.innerHTML = '<div class="tfa-box"><div class="tfa-title">🔐 Enable Two-Factor Auth</div>'
    + '<div class="tfa-sub">Loading setup...</div>'
    + '<div style="text-align:center;padding:30px;color:#0fb574">⏳</div></div>';
  document.body.appendChild(overlay);

  try {
    var data = await _2faApi('POST', '/auth/2fa/enroll', {});
    if (data.error) throw new Error(data.error);
    if (!data.qr_code) throw new Error('QR code not returned. Please enable MFA in your Supabase project: Dashboard → Authentication → Sign In Methods → Enable MFA');

    overlay.innerHTML = '<div class="tfa-box">'
      + '<div class="tfa-title">🔐 Enable Two-Factor Auth</div>'
      + '<div class="tfa-sub">Scan the QR code with your authenticator app, then enter the 6-digit code to confirm.</div>'

      // QR code
      + '<div id="tfa-qr-wrap" style="text-align:center;margin-bottom:16px"><img class="tfa-qr" id="tfa-qr-img" src="" alt="QR Code"><div id="tfa-qr-err" style="display:none;color:#f87171;font-size:11px;margin-top:8px">QR image unavailable — use manual key below</div></div>'

      // Manual secret
      + '<div style="font-size:10px;color:#7d8ba3;text-align:center;margin-bottom:6px">Can\'t scan? Enter this key manually:</div>'
      + '<div class="tfa-secret" onclick="navigator.clipboard.writeText(\'' + data.secret + '\');this.textContent=\'Copied!\';var me=this;setTimeout(function(){me.textContent=\'' + data.secret + '\'},1500)" title="Click to copy">'
      + data.secret
      + '</div>'

      // Steps
      + '<div class="tfa-steps">'
      + '<div class="tfa-step"><div class="tfa-step-n">1</div><div class="tfa-step-t">Install <strong>Google Authenticator</strong>, <strong>Authy</strong>, or any TOTP app</div></div>'
      + '<div class="tfa-step"><div class="tfa-step-n">2</div><div class="tfa-step-t">Tap <strong>+</strong> → <strong>Scan QR code</strong> and point your camera at the code above</div></div>'
      + '<div class="tfa-step"><div class="tfa-step-n">3</div><div class="tfa-step-t">Enter the <strong>6-digit code</strong> from the app below</div></div>'
      + '</div>'

      // Code input
      + _digitInputsHtml('tfa-en-')
      + '<div id="tfa-en-err" class="tfa-err"></div>'

      // Buttons
      + '<button class="tfa-btn" id="tfa-en-btn" onclick="confirm2FASetup(\'' + data.factor_id + '\')">Verify & Enable</button>'
      + '<button class="tfa-btn-sec" onclick="close2FAOverlay()">Cancel</button>'
      + '</div>';

    _2faEnrolling = false;
    _2faSetupDigits('tfa-en-', function() { window.confirm2FASetup(data.factor_id); });
    setTimeout(function() { var f = document.getElementById('tfa-en-0'); if(f) f.focus(); }, 100);

    // Load QR code — use Supabase's qr_code if available, otherwise generate from uri
    var img = document.getElementById('tfa-qr-img');
    var errEl = document.getElementById('tfa-qr-err');
    if (img) {
      var qrSrc = data.qr_code || '';
      // If Supabase qr_code is empty or not a data URI, generate from otpauth URI
      if (!qrSrc && data.uri) {
        qrSrc = 'https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=' + encodeURIComponent(data.uri);
      }
      if (qrSrc) {
        img.src = qrSrc;
        img.onerror = function() {
          this.style.display = 'none';
          if (errEl) errEl.style.display = 'block';
        };
      } else {
        img.style.display = 'none';
        if (errEl) { errEl.textContent = 'QR unavailable — use the manual key below'; errEl.style.display = 'block'; }
      }
    }

  } catch(e) {
    _2faEnrolling = false;
    overlay.innerHTML = '<div class="tfa-box">'
      + '<div class="tfa-title">Error</div>'
      + '<div class="tfa-sub" style="color:#f87171">' + e.message + '</div>'
      + '<button class="tfa-btn-sec" onclick="close2FAOverlay()">Close</button>'
      + '</div>';
  }
};

// ── Confirm 2FA setup ─────────────────────────────────────────────────────────
window.confirm2FASetup = async function(factorId) {
  var code   = _2faGetDigits('tfa-en-');
  var errEl  = document.getElementById('tfa-en-err');
  var btn    = document.getElementById('tfa-en-btn');
  if (code.length !== 6) { if(errEl) errEl.textContent = 'Enter all 6 digits'; return; }
  if (btn) { btn.disabled = true; btn.textContent = 'Verifying...'; }
  if (errEl) errEl.textContent = '';
  try {
    var data = await _2faApi('POST', '/auth/2fa/verify', { factor_id: factorId, code: code });
    if (data.error) throw new Error(data.error);

    // Success
    var overlay = document.getElementById('tfa-overlay');
    if (overlay) {
      overlay.innerHTML = '<div class="tfa-box" style="text-align:center">'
        + '<div style="font-size:48px;margin-bottom:16px">✅</div>'
        + '<div class="tfa-title">2FA Enabled!</div>'
        + '<div class="tfa-sub">Your account is now protected. You\'ll need your authenticator app each time you sign in.</div>'
        + '<button class="tfa-btn" onclick="close2FAOverlay(true)">Done</button>'
        + '</div>';
    }
  } catch(e) {
    if (errEl) errEl.textContent = e.message || 'Invalid code. Try again.';
    if (btn) { btn.disabled = false; btn.textContent = 'Verify & Enable'; }
    // Clear inputs for retry
    [0,1,2,3,4,5].forEach(function(i) {
      var el = document.getElementById('tfa-en-' + i);
      if (el) { el.value = ''; el.classList.remove('tfa-filled'); }
    });
    var f = document.getElementById('tfa-en-0');
    if (f) f.focus();
  }
};

// ── Show 2FA Disable Modal ────────────────────────────────────────────────────
window.show2FADisable = function() {
  var ex = document.getElementById('tfa-overlay');
  if (ex) ex.remove();
  var overlay = document.createElement('div');
  overlay.id = 'tfa-overlay';
  overlay.className = 'tfa-overlay';
  overlay.innerHTML = '<div class="tfa-box">'
    + '<div class="tfa-title">🔓 Disable Two-Factor Auth</div>'
    + '<div class="tfa-sub">Enter your current authenticator code to confirm you want to disable 2FA.</div>'
    + _digitInputsHtml('tfa-dis-')
    + '<div id="tfa-dis-err" class="tfa-err"></div>'
    + '<button class="tfa-btn" id="tfa-dis-btn" style="background:linear-gradient(135deg,#ef4444,#dc2626)" onclick="confirm2FADisable()">Disable 2FA</button>'
    + '<button class="tfa-btn-sec" onclick="close2FAOverlay()">Cancel</button>'
    + '</div>';
  document.body.appendChild(overlay);
  _2faSetupDigits('tfa-dis-', function() { window.confirm2FADisable(); });
  setTimeout(function() { var f = document.getElementById('tfa-dis-0'); if(f) f.focus(); }, 100);
};

window.confirm2FADisable = async function() {
  var code  = _2faGetDigits('tfa-dis-');
  var errEl = document.getElementById('tfa-dis-err');
  var btn   = document.getElementById('tfa-dis-btn');
  if (code.length !== 6) { if(errEl) errEl.textContent = 'Enter all 6 digits'; return; }
  if (btn) { btn.disabled = true; btn.textContent = 'Disabling...'; }
  if (errEl) errEl.textContent = '';
  try {
    var data = await _2faApi('POST', '/auth/2fa/unenroll', { code: code });
    if (data.error) throw new Error(data.error);
    var overlay = document.getElementById('tfa-overlay');
    if (overlay) {
      overlay.innerHTML = '<div class="tfa-box" style="text-align:center">'
        + '<div style="font-size:48px;margin-bottom:16px">🔓</div>'
        + '<div class="tfa-title">2FA Disabled</div>'
        + '<div class="tfa-sub">Two-factor authentication has been removed from your account.</div>'
        + '<button class="tfa-btn" onclick="close2FAOverlay(true)">Done</button>'
        + '</div>';
    }
  } catch(e) {
    if (errEl) errEl.textContent = e.message || 'Invalid code. Try again.';
    if (btn) { btn.disabled = false; btn.textContent = 'Disable 2FA'; }
    [0,1,2,3,4,5].forEach(function(i) {
      var el = document.getElementById('tfa-dis-' + i);
      if (el) { el.value = ''; el.classList.remove('tfa-filled'); }
    });
    var f = document.getElementById('tfa-dis-0');
    if (f) f.focus();
  }
};

// ── Close overlay + refresh profile if changed ────────────────────────────────
window.close2FAOverlay = function(refresh) {
  var overlay = document.getElementById('tfa-overlay');
  if (overlay) { overlay.style.opacity = '0'; overlay.style.transition = 'opacity .2s'; setTimeout(function(){ overlay.remove(); }, 200); }
  if (refresh) {
    // Re-fetch profile to update 2FA status badge
    if (window.S && window.S.token) {
      fetch((window.API || '') + '/profile/me', { headers: { Authorization: 'Bearer ' + window.S.token } })
        .then(function(r){ return r.json(); })
        .then(function(d){
          if (d.user) {
            window.S.user = Object.assign(window.S.user || {}, d.user);
            // Update 2FA card
            var container = document.getElementById('pf-2fa-container');
            if (container && window.render2FACard) window.render2FACard(container, d.user.totpEnabled);
          }
        }).catch(function(){});
    }
  }
};

// ══════════════════════════════════════════════════════════════════════════════
// FLOW 2 — Login TOTP Step
// ══════════════════════════════════════════════════════════════════════════════

// Call this from doLogin() when server returns requiresTOTP: true
window.show2FALoginChallenge = function(factorId, partialToken, email) {
  var ex = document.getElementById('tfa-overlay');
  if (ex) ex.remove();

  var overlay = document.createElement('div');
  overlay.id = 'tfa-overlay';
  overlay.className = 'tfa-overlay';
  overlay.innerHTML = '<div class="tfa-box">'
    + '<div style="text-align:center;margin-bottom:6px"><span style="font-size:36px">🔐</span></div>'
    + '<div class="tfa-title" style="text-align:center">Two-Factor Authentication</div>'
    + '<div class="tfa-sub" style="text-align:center">Enter the 6-digit code from your authenticator app to continue signing in as <strong>' + (email||'') + '</strong></div>'
    + _digitInputsHtml('tfa-lg-')
    + '<div id="tfa-lg-err" class="tfa-err"></div>'
    + '<button class="tfa-btn" id="tfa-lg-btn" onclick="complete2FALogin(\'' + factorId + '\',\'' + partialToken + '\')">Verify & Sign In</button>'
    + '<button class="tfa-btn-sec" onclick="close2FAOverlay();if(window.renderLogin)renderLogin();">Use a different account</button>'
    + '</div>';
  document.body.appendChild(overlay);
  _2faSetupDigits('tfa-lg-', function() { window.complete2FALogin(factorId, partialToken); });
  setTimeout(function() { var f = document.getElementById('tfa-lg-0'); if(f) f.focus(); }, 100);
};

window.complete2FALogin = async function(factorId, partialToken) {
  var code  = _2faGetDigits('tfa-lg-');
  var errEl = document.getElementById('tfa-lg-err');
  var btn   = document.getElementById('tfa-lg-btn');
  if (code.length !== 6) { if(errEl) errEl.textContent = 'Enter all 6 digits'; return; }
  if (btn) { btn.disabled = true; btn.textContent = 'Verifying...'; }
  if (errEl) errEl.textContent = '';
  try {
    // Step 1: get challenge
    var challengeData = await _2faApi('POST', '/auth/2fa/challenge', { factor_id: factorId }, partialToken);
    if (challengeData.error) throw new Error(challengeData.error);

    // Step 2: verify
    var loginData = await _2faApi('POST', '/auth/2fa/login', {
      factor_id: factorId,
      challenge_id: challengeData.challenge_id || challengeData.id,
      code: code
    }, partialToken);
    if (loginData.error) throw new Error(loginData.error);

    // Success — store session and continue
    var overlay = document.getElementById('tfa-overlay');
    if (overlay) { overlay.style.opacity = '0'; overlay.style.transition = 'opacity .2s'; setTimeout(function(){ overlay.remove(); }, 200); }

    if (loginData.token) {
      window.S = window.S || {};
      window.S.token = loginData.token;
      window.S.user  = loginData.user || window.S.user;
      localStorage.setItem('eoh_t', loginData.token);
      if (loginData.refresh_token) localStorage.setItem('eoh_rt', loginData.refresh_token);
      if (loginData.user) localStorage.setItem('eoh_u', JSON.stringify(loginData.user));
      if (window.updateUserUI) window.updateUserUI();
      if (window.closeModal)   window.closeModal();
    }
  } catch(e) {
    if (errEl) errEl.textContent = e.message || 'Invalid code. Please try again.';
    if (btn) { btn.disabled = false; btn.textContent = 'Verify & Sign In'; }
    [0,1,2,3,4,5].forEach(function(i) {
      var el = document.getElementById('tfa-lg-' + i);
      if (el) { el.value = ''; el.classList.remove('tfa-filled'); }
    });
    var f = document.getElementById('tfa-lg-0');
    if (f) f.focus();
  }
};

// ══════════════════════════════════════════════════════════════════════════════
// HOOK into doLogin — intercept requiresTOTP response
// Deferred: eoh-2fa.js loads after eoh-chat.js so window.doLogin should exist
// but we retry just in case
// ══════════════════════════════════════════════════════════════════════════════
function _hook2FAIntoLogin() {
  var _origDoLogin = window.doLogin;
  if (typeof _origDoLogin !== 'function') return false;
  // Already hooked?
  if (_origDoLogin._2faHooked) return true;
  window.doLogin = async function() {
    var em = (document.getElementById('m-em') || {}).value || '';
    var pw = (document.getElementById('m-pw') || {}).value || '';
    var err = document.getElementById('m-err');
    var rememberMe = document.getElementById('m-remember') ? document.getElementById('m-remember').checked : false;
    if (!em || !pw) { if(err) err.textContent = 'Please fill in all fields.'; return; }
    if(err) err.textContent = '';
    if(rememberMe && window._saveLoginInfo) window._saveLoginInfo(em);

    var btn = document.querySelector('.mbtn[onclick="doLogin()"]');
    if (btn) { btn.textContent = 'Signing in\u2026'; btn.disabled = true; }

    try {
      var res = await fetch((window.API || '') + '/auth/signin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ email: em, password: pw, captcha_token: window._captchaToken || '' })
      });
      var d = await res.json();

      // 2FA required
      if (d.requiresTOTP) {
        if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
        window.show2FALoginChallenge(d.factor_id, d.partial_token, d.email || em);
        return;
      }

      // Original flow continues
      if (!res.ok) {
        var msg = d.error || 'Login failed.';
        if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
        if (d.requiresConfirmation || d.requiresVerification) {
          if (window.renderEmailVerify) window.renderEmailVerify(d.email || em, pw);
          return;
        }
        if (err) err.textContent = msg;
        return;
      }
      if (d.requiresVerification) {
        if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
        window._pendingVerifyPw = pw;
        if (window.renderEmailVerify) window.renderEmailVerify(d.email || em, pw);
        return;
      }

      window.S = window.S || {};
      window.S.user = d.user; window.S.token = d.token;
      localStorage.setItem('eoh_t', d.token);
      if (d.refresh_token) localStorage.setItem('eoh_rt', d.refresh_token);
      localStorage.setItem('eoh_u', JSON.stringify(d.user));
      if (window.checkAndShowBlock && window.checkAndShowBlock(d.user)) { if(window.closeModal) window.closeModal(); return; }
      if (window.updateUserUI) window.updateUserUI();
      if (window.closeModal)   window.closeModal();

    } catch(e) {
      if (err) err.textContent = 'Cannot connect to server. Please try again.';
      if (btn) { btn.textContent = 'Sign In'; btn.disabled = false; }
    }
  };
  window.doLogin._2faHooked = true;
  return true;
}

if (!_hook2FAIntoLogin()) {
  var _2faLoginAttempts = 0;
  var _2faLoginInterval = setInterval(function() {
    _2faLoginAttempts++;
    if (_hook2FAIntoLogin() || _2faLoginAttempts > 50) clearInterval(_2faLoginInterval);
  }, 100);
}

// ══════════════════════════════════════════════════════════════════════════════
// HOOK into profile modal — inject 2FA card into Security section
// Uses a deferred hook so it works regardless of script load order
// ══════════════════════════════════════════════════════════════════════════════
function _hook2FAIntoProfile() {
  var orig = window.renderProfileForm;
  if (typeof orig !== 'function') return false;
  window.renderProfileForm = function(p) {
    orig(p);
    setTimeout(function() {
      var container = document.getElementById('pf-2fa-container');
      if (container && window.render2FACard) {
        window.render2FACard(container, p && p.totpEnabled);
      }
    }, 80);
  };
  return true;
}

// Try immediately, then retry every 100ms until profile functions are loaded
if (!_hook2FAIntoProfile()) {
  var _2faHookAttempts = 0;
  var _2faHookInterval = setInterval(function() {
    _2faHookAttempts++;
    if (_hook2FAIntoProfile() || _2faHookAttempts > 30) {
      clearInterval(_2faHookInterval);
    }
  }, 100);
}

console.log('[EOH 2FA] loaded');

})();
